import { createSlice } from "@reduxjs/toolkit";

const specimenSlice = createSlice({
    name: "specimens",
    initialState: {},
    reducers: {
        registerSpecimen: (state, action) => {
            const specimen = action.payload;

            if (!specimen?.id) return;

            // Only add if not already present
            if (!state[specimen.id]) {
                state[specimen.id] = specimen;
            } else {
                console.warn(
                    `⚠️ Specimen ${specimen.id} already exists — skipping overwrite.`
                );
            }
        },

        bulkRegisterSpecimens: (state, action) => {
            action.payload.forEach((specimen) => {
                if (!specimen?.id) return;

                if (!state[specimen.id]) {
                    state[specimen.id] = specimen;
                } else {
                    console.warn(
                        `⚠️ Specimen ${specimen.id} already exists — skipping overwrite.`
                    );
                }
            });
        }
    }
});

export const {
    registerSpecimen,
    bulkRegisterSpecimens
} = specimenSlice.actions;

export default specimenSlice.reducer;
